import '@babel/polyfill';

import './client.js';
